<template>
  <div>
    <div
      class="mb-2 flex w-full flex-row flex-wrap gap-y-4 border-2 border-orange p-4"
    >
      <div
        class="flex basis-full content-center gap-x-2 text-orange lg:basis-1/2"
      >
        <span class="text-3xl font-bold lg:text-6xl">Q.</span>
        <span class="text-lg lg:text-2xl"
          >What's the best way to use the next 2 minutes?</span
        >
      </div>

      <div
        class="flex basis-full content-center gap-x-2 text-orange lg:basis-1/2"
      >
        <span class="text-3xl font-bold lg:text-6xl">A.</span>
        <span class="text-lg lg:text-2xl"
          >Upload your CV and let the right jobs and recruiters find you!</span
        >
      </div>
      <p class="basis-full text-grey-60 lg:basis-4/6 lg:pr-2 lg:text-xl">
        Save yourself hours of searching by uploading or updating your CV on our
        partner site
        <span class="whitespace-nowrap font-bold text-grey-80"
          >CV-Library.co.uk</span
        >. With over
        <span class="whitespace-nowrap font-bold text-grey-80">200,000</span>
        live vacancies, your next {{ industry }} job {{ locationText }} could be
        in your inbox tomorrow.
      </p>
      <a
        rel="nofollow"
        href="https://www.cv-library.co.uk/register?id=103281"
        target="_blank"
        class="block h-full basis-full rounded bg-orange py-2 text-center align-middle font-bold text-white drop-shadow-lg lg:basis-2/6"
      >
        Upload your CV and <br />
        Apply for jobs
      </a>
    </div>
    <span class="block w-full text-xs text-grey-80">Advertisement</span>
  </div>
</template>

<script>
export default {
  name: 'AdvertCvLibrary',
  props: {
    industry: {
      type: String,
      default: '',
    },
    location: {
      type: String,
      default: '',
    },
  },
  computed: {
    locationText() {
      return this.location.trim() ? `in ${this.location.trim()}` : '';
    },
  },
};
</script>
